import moment from "moment"

const initialState = {
  isLoading: false,
  quotations: [],
  totalQuotations: 0,
  totalPages: 0,
  newQuotation: {
    id: "",
    quotationProducts: [],
    senderAddress: "184, Buthgamuwa Road",
    senderCity: "Rajagiriya, Sri Lanka",
    senderTel: "0112 805 005 / 0761 399 060 / 0761 399 063",
    date: moment().format("YYYY-MM-DD"),
    quotationNumber: "",
    salesManager: "",
    paymentTerms: "On Delivery",
    deliverTo: "",
    customer: {},
    transport: "",
    quoteType: "Sales",
    oldSN: "",
    oldInvoiceNum: "",
    modelType: "",
    troubleshootingRef: "",
    rrnRef: "",
    serviceCharge: "",
    preOrder: false,
    copiedFrom: "",
  },
}

const QuotationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_QUOTATION_LOADING":
      return {
        ...state,
        isLoading: action.data,
      }
    case `SET_QUOTATIONS`:
      return {
        ...state,
        quotations: action.data,
      }

    case `SET_TOTAL_QUOTATIONS`:
      return {
        ...state,
        totalQuotations: action.data,
      }

    case `SET_TOTAL_PAGES`:
      return {
        ...state,
        totalPages: action.data,
      }
    case `SET_QUOTATION_PRODUCTS`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, quotationProducts: action.data },
      }
    case `SET_QUOTE_DATE`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, date: action.data },
      }
    case `SET_QUOTATION_NUMBER`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, quotationNumber: action.data },
      }
    case `SET_QUOTE_SALES_MANAGER`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, salesManager: action.data },
      }
    case `SET_QUOTE_PAYMENT_TERMS`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, paymentTerms: action.data },
      }
    case `SET_QUOTE_DELIVER_TO`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, deliverTo: action.data },
      }
    case `SET_QUOTE_CUSTOMER`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, customer: action.data },
      }
    case `SET_QUOTE_TRANSPORT`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, transport: action.data },
      }
    case `SET_QUOTE_TYPE`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, quoteType: action.data },
      }
    case `SET_QUOTE_TROUBLESHOOTING_REF`:
      return {
        ...state,
        newQuotation: {
          ...state.newQuotation,
          troubleshootingRef: action.data,
        },
      }

    case `SET_QUOTE_RRN_REF`:
      return {
        ...state,
        newQuotation: {
          ...state.newQuotation,
          rrnRef: action.data,
        },
      }

    case `SET_QUOTE_SERVICE_CHARGE`:
      return {
        ...state,
        newQuotation: {
          ...state.newQuotation,
          serviceCharge: action.data,
        },
      }

    case `SET_QUOTE_OLD_SN`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, oldSN: action.data },
      }
    case `SET_QUOTE_OLD_INVOICE_NUM`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, oldInvoiceNum: action.data },
      }
    case `SET_QUOTE_MODEL_TYPE`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, modelType: action.data },
      }

    case `SET_QUOTE_PRE_ORDER`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, preOrder: action.data },
      }

    case `SET_QUOTE_ID`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, id: action.data },
      }
    case `SET_QUOTE_COPIED_FROM`:
      return {
        ...state,
        newQuotation: { ...state.newQuotation, copiedFrom: action.data },
      }
    case `CLEAR_NEW_QUOTATION`:
      return {
        ...state,
        newQuotation: { ...initialState.newQuotation },
      }

    default:
      return state
  }
}

export default QuotationReducer
